// @ts-strict-ignore
import {Injectable, Injector} from "@angular/core";
import {ControlPanel, ControlPanelLocation} from "@models";
import Enumerable from "linq";
import {SimUserInterfaceService} from "../../../api/generated/service";
import {SimWindowService} from "./sim-window.service";
import {PanelOptions} from "@common/components/panels/panel-base/panel-base";

@Injectable({
	providedIn: "root",
})
export class SimUserInterfaceServiceExtended extends SimUserInterfaceService {
	constructor(
		injector: Injector,
		protected _simWindowService: SimWindowService,
	) {
		super(injector);
	}

	public getPanels(controlPanelLocation: ControlPanelLocation) {
		return super.getControlPanels(controlPanelLocation).then((result) => {
			const panels = result;

			const panelOptions: PanelOptions = {
				activePanel: null,
				activeUndockedPanel: null,
			};

			panelOptions.activePanel = Enumerable.from(panels).firstOrDefault((panel) => panel.isOpen && !this.showUndocked(panel));

			panelOptions.activeUndockedPanel = Enumerable.from(panels).firstOrDefault((panel) => this.showUndocked(panel));

			return {
				panels: panels,
				panelOptions: panelOptions,
			};
		});
	}

	public showUndocked(panel: ControlPanel) {
		return panel.undocked && this._simWindowService.isTwoScreenVal;
	}
}
